/**
 * Check if given element is detached, i.e is not present in the DOM.
 *
 * @param {HTMLElement} node DOM Node.
 * @return {boolean} `true` if `node` is detached, `false` otherwise.
 */
export function isDetachedElement(node) {
    if ('isConnected' in node) {
        return !node.isConnected;
    }

    // Fallback for old versions of Safari
    return !document.contains(node);
}
